import { NumberFormatOptions } from "@formatjs/ecma402-abstract"

const numberFormatOptions: NumberFormatOptions = { style: 'currency', currency: "USD" };

const formattersCache = new Map<string, Intl.NumberFormat>();

const getFormatter = (currency: string = "USD", locale: string = "en-US"): Intl.NumberFormat => {
  const cacheKey = `${locale}-${currency}`;
  if (formattersCache.has(cacheKey)) {
    return formattersCache.get(cacheKey)!;
  }

  try {
    const formatter = new Intl.NumberFormat(locale, { style: "currency", currency });
    formattersCache.set(cacheKey, formatter);
    return formatter;
  } catch (e) {
    console.warn(`Invalid currency code "${currency}" provided. Falling back to USD.`);
    const usdFormatter = getFormatter("USD", locale);
    formattersCache.set(cacheKey, usdFormatter); // Cache the USD formatter under the invalid currency key.
    return usdFormatter;
  }
};

const CurrencyUtils = {
  format: numberFormatOptions,

  /**
   * Formats a number as a currency string (e.g., $1,234.56). Defaults to USD.
   *
   * @param value The number to format.
   * @param currency The ISO 4217 currency code (e.g., 'CAD'). Defaults to 'USD'.
   * @returns The formatted currency string, or an empty string if the value is null or undefined.
   */
  formatNumber: (value: number | null | undefined, currency: string = "USD"): string => {
    if (value == null || !Number.isFinite(value)) {
      return "";
    }
    return getFormatter(currency).format(value);
  },
};

export default CurrencyUtils;
